<template>
  <path
    d="M17 7.00018H7C4.24 7.00018 2 9.24018 2 12.0002C2 14.7602 4.24 17.0002 7 17.0002H17C19.76 17.0002 22 14.7602 22 12.0002C22 9.24018 19.76 7.00018 17 7.00018ZM17 15.0002C15.34 15.0002 14 13.6602 14 12.0002C14 10.3402 15.34 9.00018 17 9.00018C18.66 9.00018 20 10.3402 20 12.0002C20 13.6602 18.66 15.0002 17 15.0002Z"
  />
</template>
